import React from "react";
import { Card, FormCheck, FormControl } from "react-bootstrap";
import ConfirmDelete from "./ConfirmDelete";

interface IConfCampoIntervaloDataProps {
  titulo: string;
  obrigatorio: boolean;

  onTitleChange: (titulo: string) => void;
  onDelete: () => void;
  onRequiredChange: (obrigatorio: boolean) => void;
}

export function ConfCampoIntervaloData({
  titulo,
  obrigatorio,
  onTitleChange,
  onRequiredChange,
  onDelete,
}: IConfCampoIntervaloDataProps) {
  return (
    <Card>
      <Card.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Card.Title>Intervalo de Datas</Card.Title>
        <ConfirmDelete onDelete={onDelete} />
      </Card.Header>

      <Card.Body>
        <div className="mb-3">
          <label>Título</label>

          <FormControl
            value={titulo}
            onChange={(e) => onTitleChange(e.target.value)}
          />
        </div>

        <FormCheck
          type="checkbox"
          label="Obrigatório"
          checked={obrigatorio}
          onChange={(e) => onRequiredChange(e.target.checked)}
        />
      </Card.Body>
    </Card>
  );
}
